import { render, staticRenderFns } from "./TransactionHistoryItem.vue?vue&type=template&id=348abd43"
import script from "./TransactionHistoryItem.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports